import { render, staticRenderFns } from "./DeskRequest.vue?vue&type=template&id=7eb2e6b6&scoped=true&"
import script from "./DeskRequest.vue?vue&type=script&lang=ts&"
export * from "./DeskRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb2e6b6",
  null
  
)

export default component.exports